// ** React Imports
// ** Vertical Menu Items Array
import navigation from "@src/navigation/vertical";
// ** Third Party Components
import classnames from "classnames";
import { Fragment, useEffect, useRef, useState } from "react";
import { Moon, Sun, Twitter, Youtube } from "react-feather";
import PerfectScrollbar from "react-perfect-scrollbar";
// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader";
import VerticalNavMenuItems from "./VerticalNavMenuItems";

const Sidebar = (props) => {
    // ** Props
    const {
        menuCollapsed,
        routerProps,
        menu,
        currentActiveItem,
        skin,
        setSkin,
    } = props;

    // ** States
    const [groupOpen, setGroupOpen] = useState([]);
    const [groupActive, setGroupActive] = useState([]);
    const [activeItem, setActiveItem] = useState(null);

    // ** Menu Hover State
    const [menuHover, setMenuHover] = useState(false);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    const handleWindowHeight = () => {
        setWindowHeight(window.innerHeight);
    };

    useEffect(() => {
        if (window !== undefined) {
            window.addEventListener("resize", handleWindowHeight);
        }
    }, [windowHeight]);

    console.log(windowHeight);

    // ** Ref
    const shadowRef = useRef(null);

    // ** Function to toggle Theme (Light/Dark)
    const ThemeToggler = () => {
        if (skin === "dark") {
            return <Sun className="ficon" onClick={() => setSkin("light")} />;
        } else {
            return <Moon className="ficon" onClick={() => setSkin("dark")} />;
        }
    };

    const svgColorToggler = () => {
        if (skin === "dark") {
            return "#fff";
        } else {
            return "#000";
        }
    };

    // ** Function to handle Mouse Enter
    const onMouseEnter = () => {
        if (menuCollapsed) {
            setMenuHover(true);
        }
    };

    // ** Scroll Menu
    const scrollMenu = (container) => {
        if (shadowRef && container.scrollTop > 0) {
            if (!shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.add("d-block");
            }
        } else {
            if (shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.remove("d-block");
            }
        }
    };

    return (
        <Fragment>
            <div
                className={classnames(
                    "main-menu menu-fixed menu-accordion menu-shadow",
                    {
                        expanded: menuHover || menuCollapsed === false,
                        "menu-light": skin !== "semi-dark" && skin !== "dark",
                        "menu-dark": skin === "semi-dark" || skin === "dark",
                    }
                )}
                onMouseEnter={onMouseEnter}
                onMouseLeave={() => setMenuHover(false)}
            >
                {menu ? (
                    menu(props)
                ) : (
                    <Fragment>
                        {/* Vertical Menu Header */}
                        <VerticalMenuHeader
                            setGroupOpen={setGroupOpen}
                            menuHover={menuHover}
                            {...props}
                        />
                        {/* Vertical Menu Header Shadow */}
                        <div className="shadow-bottom" ref={shadowRef}></div>
                        {/* Perfect Scrollbar */}
                        <PerfectScrollbar
                            className="main-menu-content"
                            options={{ wheelPropagation: false }}
                            onScrollY={(container) => scrollMenu(container)}
                        >
                            <ul className="navigation navigation-main">
                                <VerticalNavMenuItems
                                    items={navigation}
                                    groupActive={groupActive}
                                    setGroupActive={setGroupActive}
                                    activeItem={activeItem}
                                    setActiveItem={setActiveItem}
                                    groupOpen={groupOpen}
                                    setGroupOpen={setGroupOpen}
                                    routerProps={routerProps}
                                    menuCollapsed={menuCollapsed}
                                    menuHover={menuHover}
                                    currentActiveItem={currentActiveItem}
                                />
                            </ul>

                            <div
                                // style={{
                                //   position: 'absolute',
                                //   bottom: 80,
                                //   left: 0,
                                // }}
                                className="pb-5"
                                style={{ marginTop: "90px" }}
                            >
                                <div className="mt-lg-5 mt-md-5 mt-0">
                                    <ul className="navigation navigation-main">
                                        <li className="navigation-header mt-lg-5 mt-md-5 mt-0 pt-lg-5 pt-md-5 pt-0">
                                            THE CLUB GUILD
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="d-flex align-items-center"
                                                href="https://discord.gg/the-sa-club"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-discord"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
                                                </svg>
                                                <span>Discord</span>
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a
                                                className="d-flex align-items-center"
                                                href="https://twitter.com/TheClubGuild"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <Twitter className="ficon" />
                                                <span>Twitter</span>
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a
                                                className="d-flex align-items-center"
                                                href="https://www.youtube.com/channel/UCMTp0p-oOsZB8UETrCr53XA"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <Youtube className="ficon" />
                                                <span>Youtube</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="mt-2 pb-2">
                                    <ul className="navigation navigation-main">
                                        <li className="navigation-header mt-0 pt-0">
                                            IN PARTNERSHIP WITH
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="d-flex align-items-center"
                                                href="https://step.finance/?mtm_campaign=theclub"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="112"
                                                    height="47"
                                                    viewBox="0 0 112 47"
                                                    fill="none"
                                                    className="step-logo"
                                                >
                                                    <path
                                                        d="M65.3214 32.4817C66.5421 32.4817 67.6083 32.2574 68.5199 31.8088C69.447 31.3441 70.1732 30.7113 70.6986 29.9101C71.224 29.093 71.4866 28.1637 71.4866 27.1223C71.4866 24.7189 70.1037 23.0526 67.3378 22.1233L64.0234 21.0178C62.9727 20.6493 62.4474 20.0404 62.4474 19.1912C62.4474 18.6144 62.6714 18.1498 63.1195 17.7973C63.5676 17.4288 64.1548 17.2445 64.881 17.2445C65.7154 17.2445 66.4571 17.4848 67.1061 17.9655C67.755 18.4302 68.2418 19.0791 68.5663 19.9122L71.4866 18.5423C71.0076 17.1324 70.1732 16.0268 68.9835 15.2257C67.8091 14.4086 66.4416 14 64.881 14C63.7067 14 62.6637 14.2243 61.752 14.6729C60.8558 15.1216 60.1528 15.7464 59.6429 16.5475C59.1484 17.3487 58.9012 18.278 58.9012 19.3354C58.9012 21.7708 60.2841 23.4612 63.05 24.4065L66.4339 25.5601C67.4537 25.9126 67.9636 26.5054 67.9636 27.3386C67.9636 27.9154 67.7396 28.38 67.2915 28.7325C66.8588 29.069 66.2794 29.2372 65.5532 29.2372C64.6261 29.2372 63.7762 28.9568 63.0036 28.396C62.2465 27.8352 61.6516 27.0662 61.219 26.0888L58.2754 27.4587C58.6153 28.4842 59.1252 29.3734 59.8051 30.1264C60.5004 30.8795 61.3194 31.4643 62.2619 31.8809C63.22 32.2814 64.2398 32.4817 65.3214 32.4817Z"
                                                        fill={svgColorToggler()}
                                                    />
                                                    <path
                                                        d="M79.8876 32.3375C80.4593 32.3375 81.0002 32.2975 81.5101 32.2173V29.1411C81.1856 29.1891 80.9152 29.2132 80.6988 29.2132C79.2618 29.2132 78.5433 28.5482 78.5433 27.2184V22.1954H81.5101V19.0711H78.5433V16.0909H75.0667V17.0522C75.0667 18.3981 74.3945 19.0711 73.0502 19.0711H72.9343V22.1954H75.0667V27.4587C75.0667 28.9969 75.4839 30.1985 76.3183 31.0637C77.1681 31.9129 78.3579 32.3375 79.8876 32.3375Z"
                                                        fill={svgColorToggler()}
                                                    />
                                                    <path
                                                        d="M89.6431 32.4817C90.941 32.4817 92.0767 32.1933 93.0502 31.6165C94.0236 31.0237 94.7035 30.2466 95.0898 29.2853L92.3085 27.9154C92.0613 28.364 91.7136 28.7165 91.2655 28.9728C90.8328 29.2292 90.3075 29.3574 89.6894 29.3574C88.8396 29.3574 88.1442 29.109 87.6034 28.6123C87.0626 28.1156 86.7459 27.4587 86.6531 26.6416H95.507C95.5688 26.4653 95.6074 26.2571 95.6229 26.0167C95.6538 25.7604 95.6692 25.504 95.6692 25.2476C95.6692 24.03 95.422 22.9404 94.9276 21.9791C94.4486 21.0017 93.7455 20.2247 92.8184 19.6479C91.8913 19.0711 90.7556 18.7827 89.4113 18.7827C88.206 18.7827 87.1244 19.0791 86.1664 19.6719C85.2084 20.2647 84.4435 21.0738 83.8718 22.0993C83.3156 23.1247 83.0374 24.2943 83.0374 25.6082C83.0374 26.8739 83.3078 28.0275 83.8486 29.069C84.3895 30.1104 85.1543 30.9436 86.1432 31.5684C87.1321 32.1773 88.2988 32.4817 89.6431 32.4817ZM89.4113 21.6667C90.1221 21.6667 90.7092 21.883 91.1728 22.3156C91.6363 22.7482 91.9067 23.309 91.984 23.9979H86.7227C86.8926 23.2449 87.2094 22.6681 87.673 22.2675C88.152 21.8669 88.7314 21.6667 89.4113 21.6667Z"
                                                        fill={svgColorToggler()}
                                                    />
                                                    <path
                                                        d="M97.7165 37H101.193V31.1839C101.641 31.6165 102.174 31.945 102.792 32.1693C103.426 32.3776 104.098 32.4817 104.809 32.4817C106.045 32.4817 107.15 32.1773 108.123 31.5684C109.097 30.9596 109.862 30.1344 110.418 29.093C110.99 28.0515 111.275 26.8979 111.275 25.6322C111.275 24.3504 110.99 23.1968 110.418 22.1714C109.846 21.1299 109.074 20.3048 108.1 19.6959C107.127 19.0871 106.037 18.7827 104.832 18.7827C103.148 18.7827 101.858 19.3354 100.961 20.441V19.0711H97.7165V37ZM104.392 29.2372C103.449 29.2372 102.676 28.9087 102.074 28.2518C101.487 27.5789 101.193 26.7057 101.193 25.6322C101.193 24.5747 101.487 23.7095 102.074 23.0366C102.676 22.3636 103.449 22.0272 104.392 22.0272C105.35 22.0272 106.138 22.3716 106.756 23.0606C107.374 23.7335 107.683 24.5907 107.683 25.6322C107.683 26.6897 107.374 27.5549 106.756 28.2278C106.138 28.9007 105.35 29.2372 104.392 29.2372Z"
                                                        fill={svgColorToggler()}
                                                    />
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M40.7111 32.897L40.7104 14.1069L24.4224 4.70221L24.4231 23.4998L8.1394 32.9003L24.4282 42.3038L40.7012 32.9094L40.7111 32.9151V32.9037L40.7169 32.9003L40.7111 32.897Z"
                                                        fill="#64C557"
                                                    />
                                                    <path
                                                        d="M8.14437 14.1065L24.4324 4.70182L24.4317 23.51L8.14367 32.9148L8.14437 14.1065Z"
                                                        fill="#118AB2"
                                                    />
                                                    <path
                                                        d="M24.4342 4.6839L40.723 14.0874L35.2934 17.2219L19.0046 7.8184L24.4342 4.6839Z"
                                                        fill="#00F8B7"
                                                    />
                                                    <path
                                                        d="M35.2813 17.2162L35.2816 23.4856L18.9935 14.0809L18.9933 7.81149L35.2813 17.2162Z"
                                                        fill="#09BD8E"
                                                    />
                                                    <path
                                                        d="M18.9823 14.0904L35.2711 23.4939L29.8415 26.6284L13.5527 17.2249L18.9823 14.0904Z"
                                                        fill="#FFE3A3"
                                                    />
                                                    <path
                                                        d="M29.9061 26.6609L29.9063 32.9303L13.6183 23.5255L13.6181 17.2561L29.9061 26.6609Z"
                                                        fill="#FFBB1D"
                                                    />
                                                    <path
                                                        d="M13.569 23.4963L29.8577 32.8998L24.4282 36.0343L8.1394 26.6308L13.569 23.4963Z"
                                                        fill="#FF965E"
                                                    />
                                                    <path
                                                        d="M24.4161 36.0287L24.4163 42.2981L8.1283 32.8933L8.12806 26.6239L24.4161 36.0287Z"
                                                        fill="#D94C00"
                                                    />
                                                    <path
                                                        d="M35.2882 17.2181L40.7175 14.0831L40.7168 32.8914L35.2875 36.0263L35.2882 17.2181Z"
                                                        fill="#06D6A0"
                                                    />
                                                    <path
                                                        d="M29.8476 26.6246L35.2769 23.4897L35.2764 36.0285L29.8471 39.1634L29.8476 26.6246Z"
                                                        fill="#FFD166"
                                                    />
                                                    <path
                                                        d="M24.4067 36.0306L29.836 32.8957L29.8358 39.1651L24.4064 42.3L24.4067 36.0306Z"
                                                        fill="#F3722C"
                                                    />
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <span
                                        role="button"
                                        style={{
                                            marginLeft: "30px",
                                        }}
                                    >
                                        <ThemeToggler />
                                    </span>
                                </div>
                            </div>
                        </PerfectScrollbar>
                    </Fragment>
                )}
            </div>
        </Fragment>
    );
};

export default Sidebar;
